<div>
  <input #input type="number" [value]="data" (change)="onChange($event);" hidden>
  <span class="label">{{label}}</span>
  <span *ngIf="badge" class="lib-badge bg-yellow text-black">{{badge}}</span>
  <span class="lib-spacer"></span>
  <button type="button" class="lib-button" [disabled]="input.disabled || disableMin" (click)="subtract($event)">
    <lib-icon name="minus"></lib-icon>
  </button>
  <span class="value">{{valueDisplay}}</span>
  <button type="button" class="lib-button" [disabled]="input.disabled || disableMax" (click)="add($event)">
    <lib-icon name="plus"></lib-icon>
  </button>
</div>
